import { useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';

import { Message } from '@components';
import { FormFieldset, TextField } from '@Forms/fields.jsx';
import { slugifyUnderscore, slugifyOnBlur } from '@Forms/formatters.js';
import { errorsFromMutate } from '@Forms/utils.js';
import { ButtonSpinnerIcon } from '@svgs';

export const MenuForm = ({ disabled, mutation, onCancel, siteID }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setError,
    setFocus,
    setValue,
  } = useForm({
    mode: 'onBlur',
  });
  const { isDirty, isValid } = useFormState({ control });

  useEffect(() => {
    // set focus to the name field if this is a new project
    setFocus('name');
  }, [setFocus]);

  const onSubmit = (data) => {
    // set site ID
    data.site_id = siteID;

    mutation.mutate(data, {
      onError: (error) => {
        // handle server-side validations and errors
        const errorsList = errorsFromMutate(error);
        errorsList.forEach(({ field, error }) => setError(field, error));
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={
        `sb-manage-content-form ` + (disabled ? 'sb-form-disabled' : '')
      }
    >
      <FormFieldset>
        <TextField
          register={register}
          error={errors.name}
          name={`name`}
          label="Menu name"
          options={{
            onBlur: (e) => {
              slugifyOnBlur(e, '_');
              setValue('name', e.target.value, {
                shouldDirty: true,
                shouldValidate: true,
              });
            },
            onChange: slugifyUnderscore,
            required: 'This field is required',
          }}
        />
      </FormFieldset>
      <div className="sb-manage-content-button-bar">
        <div className="sb-flex">
          <button
            className="sb-btn-cancel sb-btn"
            onClick={onCancel}
            disabled={disabled}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="sb-btn sb-btn-save"
            disabled={disabled}
          >
            {mutation.isPending ? 'Creating...' : 'Create new'}
            {mutation.isPending && <ButtonSpinnerIcon />}
          </button>
        </div>
        {!isValid && isDirty && (
          <Message messageStyle="error" title="Please review your form" />
        )}
        {mutation.isError && (
          <Message
            messageStyle="error"
            title="Error saving changes"
            message="Please review your form"
          />
        )}
        {mutation.isSuccess && (
          <Message messageStyle="success" title="Successfully saved" />
        )}
      </div>
    </form>
  );
};
